"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("./utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/* eslint-disable max-len */

var UserStatusIconOnCall = /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("circle", {
  className: "presence-border",
  cx: "7",
  cy: "7",
  r: "7",
  fill: "white"
}), /*#__PURE__*/_react["default"].createElement("circle", {
  cx: "7",
  cy: "7",
  r: "5",
  fill: "#CB2233"
}), /*#__PURE__*/_react["default"].createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.21755 5.99005C6.36125 5.75161 6.51433 5.46753 6.48081 5.26664C6.45046 5.08659 5.97556 4.44021 5.75096 4.2213C5.63278 4.10606 5.50102 4.03448 5.34612 4.02812L5.33824 4.02794C4.94615 4.02625 4.373 4.51862 4.15346 4.86719C3.91567 5.18224 3.89441 5.5878 4.07105 6.04879L4.09903 6.11835C4.56292 7.36344 6.42218 9.20978 7.66838 9.68436C8.14392 9.88976 8.57632 9.87566 8.92741 9.61753C9.23431 9.43448 9.74944 8.84689 9.75212 8.4448C9.74558 8.2797 9.67384 8.1477 9.55876 8.02963C9.34019 7.80531 8.69345 7.33011 8.51402 7.29977C8.3296 7.26882 8.0643 7.50989 7.86065 7.62742L7.785 7.67232C7.64 7.75949 7.58882 7.77552 7.52284 7.75407C6.82744 7.49477 6.34172 7.07102 6.0793 6.36759C6.0625 6.31532 6.11651 6.16362 6.18268 6.04879L6.21755 5.99005Z",
  fill: "white"
}));
var _default = (0, _utils.createSvgIcon)(UserStatusIconOnCall);
exports["default"] = _default;